import React from "react";
import "../styles.scss";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { sanitize } from "../../../../Common/Util";

function PartnerDetail(props) {
  const navigate = useNavigate();
  const location = useLocation();
  const { title, description, image } = location.state || {};

  const backToNetwork = () => {
    navigate(`/ssl-network`, { state: { activeTab: "2" } });
  };

  return (
    <div className="about-ssg">
      {/* Header section */}
      <div className="header-ssl-network">
        <div className="back-to-list normal-text" onClick={backToNetwork}>
          <button>
            <ion-icon
              name="chevron-back-outline"
              className="icon back-icon"
              size="large"
            ></ion-icon>{" "}
            PARTNER
          </button>
        </div>
        <h1 className="network-title title-1 global-title-margin"> {title}</h1>
      </div>

      {/* Image */}
      <div className="image-wrapper my-4">
        <img src={image} alt={title} className="post-img object-cover" />
      </div>
      <div className="my-4 normal-text-nw flex flex-col mx-wrapper">
        <span
          className="leading-relaxed text-justify normal-text"
          dangerouslySetInnerHTML={sanitize(description)}
        />
      </div>
    </div>
  );
}

export default PartnerDetail;
